import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_CAMPAIGN:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.campaignSelected) {
        return {
          label: action.campaignSelected.name,
          value: action.campaignSelected.id,
          key: `${action.campaignSelected.id}CampaignTaskFormSelect`,
        }
      }
      return null
    case ActionType.Tasks.CHANGE_AUTOMATION_TYPE:
      return null
    default:
      return state
  }
}
